import { createContext } from "react";

export const SecondInputFormDataContext = createContext("");
